import {
  FilterOperator,
  OrderType,
  QSetStatus,
  useSearchQSetsQuery,
} from '@exam-management/graphql';
import { ErrorBox } from '@shared/components';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { QSetDataGrid } from '../../components';
import type { QSetReviewTaskCreationFormInput } from '../../schemas';

import { columns } from './columns';

export default function QSetList() {
  const { setValue, watch } = useFormContext<QSetReviewTaskCreationFormInput>();
  const examCourseId = watch('examCourseSelection.examCourse')?.value ?? '';
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const {
    data,
    loading: isLoading,
    error,
  } = useSearchQSetsQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      searchQSetsInput: {
        paging: {
          currentPage: page,
          pageSize: pageSize,
        },
        order: {
          field: 'updatedAt',
          type: OrderType.Desc,
        },
        filter: {
          conditions: [
            {
              field: 'examCourseId',
              operator: FilterOperator.Equal,
              value: examCourseId,
            },
            {
              field: 'status',
              operator: FilterOperator.Equal,
              value: QSetStatus.Draft,
            },
          ],
        },
      },
    },
  });

  const qsets = data?.excSearchQSets.qSets ?? [];
  const qsetsTotal = data?.excSearchQSets.total ?? 0;

  if (error) {
    return <ErrorBox />;
  }

  return (
    <QSetDataGrid
      columns={columns}
      rows={qsets}
      total={qsetsTotal}
      page={page}
      pageSize={pageSize}
      loading={isLoading}
      onPageChange={(_, newPage) => {
        setPage(newPage);
      }}
      onRowsPerPageChange={(event) => {
        const newPageSize = parseInt(event.target.value);
        setPageSize(newPageSize);
        setPage(0);
      }}
      onRowSelectionModelChange={(selectedRowIds) => {
        setValue('qsetSelection.qsetId', selectedRowIds.map(String));
      }}
      selectionModel={watch('qsetSelection.qsetId')}
    />
  );
}
